<template>
	<CRow>
		<CCol md="2" class="m-auto">
			<img
				class="default-image"
				data-test-id="defaultImage"
				:src="thumbnail"
			>
		</CCol>

		<CCol v-if="canSetPreviewImage" md="2" class="align-self-center">
			<BaseInputImage
				data-test-id="previewImage"
				:thumbnail="imagePreviewUrl"
				title="Add Image"
				class="mr-4 input-image"
				@onClick="handleClickPreviewImage"
				@onDelete="handleDeletePreviewImage"
			/>
		</CCol>

		<CCol md class="name-container">
			<!-- Item name -->
			<div v-if="isShowName" class="typo-body-2" data-test-id="name">
				<span class="font-weight-bold">Title:&nbsp;</span>
				<span>{{ title }}</span>
			</div>

			<!-- Type -->
			<div class="typo-body-2" data-test-id="type">
				<span class="font-weight-bold">Type:&nbsp;</span>
				<span>{{ CONTENT_TYPE_LABEL[type] }}</span>
			</div>

			<!-- Product/Category name -->
			<div v-if="isShowItemName" class="typo-body-2" data-test-id="contentName">
				<span class="font-weight-bold">{{ CONTENT_TYPE_LABEL[type] }} name:&nbsp;</span>
				<span>{{ contentName }}</span>
			</div>
			<div v-if="isShowLowestPrice">
				<span class="typo-body-2 font-weight-bold">Lowest Price Status:&nbsp;</span>
				<CBadge class="badge-status" :color="LOWEST_PRICE_STATUS_OBJECT[isLowestPriceVisible].value">
					{{ LOWEST_PRICE_STATUS_OBJECT[isLowestPriceVisible].label }}
				</CBadge>
			</div>
		</CCol>

		<!-- Button -->
		<CCol md="2" class="d-flex flex-column justify-content-center align-items-end">
			<div class="d-flex mb-2">
				<CButton class="btn-edit pl-0 pr-3" @click.prevent="handleEdit">
					<CIcon name="cil-pencil" />
				</CButton>
				<CButton class="btn-delete pl-0 pr-0" @click.prevent="handleRemove">
					<CIcon name="cil-trash" />
				</CButton>
			</div>
		</CCol>
	</CRow>
</template>

<script>

import {
	LOWEST_PRICE_STATUS_OBJECT,
} from '../enums/status';

import { IMAGE_PLACEHOLDER_URL } from '../enums/general';
import { CONTENT_TYPE, CONTENT_TYPE_LABEL } from '../enums/navigationMenu';

export default {
	name: 'NavigationMenuItem',

	props: {
		itemId: {
			// Category id, product sku, banner id
			type: Number,
			default: null,
		},
		thumbnail: {
			type: String,
			default: IMAGE_PLACEHOLDER_URL,
		},
		imagePreviewUrl: {
			type: String,
			default: '',
		},
		title: {
			type: String,
			default: '',
		},
		type: {
			type: String,
			default: '',
		},
		contentName: {
			// Category name, product name
			type: String,
			default: '',
		},
		isLowestPriceVisible: {
			type: Boolean,
			default: false,
		},
		forceCanSetPreview: {
			type: Boolean,
			default: false,
		},
		forceShowName: {
			type: Boolean,
			default: false,
		},
	},

	data() {
		return {
			LOWEST_PRICE_STATUS_OBJECT,
			CONTENT_TYPE_LABEL,
		};
	},

	computed: {
		canSetPreviewImage() {
			return this.forceCanSetPreview || this.type !== CONTENT_TYPE.banner;
		},
		isShowName() {
			return this.forceShowName || this.type !== CONTENT_TYPE.banner;
		},
		isShowItemName() {
			return this.type !== CONTENT_TYPE.banner;
		},
		isShowLowestPrice() {
			return this.type !== CONTENT_TYPE.banner;
		},
	},

	methods: {
		handleClickPreviewImage() {
			this.$emit('onOpenMedia');
		},
		handleDeletePreviewImage() {
			this.$emit('onDeleteMedia');
		},
		handleEdit() {
			this.$emit('onEdit', this.type);
		},
		handleRemove() {
			this.$emit('onRemove');
		},
	},
};
</script>

<style lang="scss" scoped>
$image-size: rem(70);

.default-image {
	height: $image-size;
	width: $image-size;
}

.input-image::v-deep {
	.image-placeholder {
		height: $image-size;
		width: $image-size;

		img {
			height: rem(20);
			width: rem(20);
		}
	}

	.image-link {
		height: $image-size;
		width: $image-size;

		.image-preview {
			height: $image-size;
			width: $image-size;
		}
	}
}
</style>